import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getFiltrarFacturas, getFiltrarUsuarios, getLocalesFiltrarPorNombre } from "../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FacturasTableComponent from "./components/FacturasTableComponent";
import FitrosFacturasComponent from "./components/FitrosFacturasComponent";

const optionsProcesados = [
    { label: 'Todos', value: "todos", id: 1 },
    { label: 'Sistema', value: "sistema", id: 2 },
    { label: 'Usuarios del sistema', value: "usuario_sistema", id: 3 },
    //   { label: 'Atención al cliente', value: "atencion_al_cliente", id: 4 }, ,
];

const optionsEstado = [
    { label: 'Activo', value: "activo", id: 1 },
    { label: 'Eliminados', value: "eliminados", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];

function FacturasPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataFacturas, setDataFacturas] = useState([]);


    const [nroFactura, setNroFactura] = useState('');
    const [montoDesde, setMontoDesde] = useState('');
    const [montoHasta, setMontoHasta] = useState('');

    const [locales, setLocales] = useState([]);
    const [localesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);

    const [estadosSelected, setEstadosSelected] = useState(null);

    const [dataClientes, setDataClientes] = useState([]);
    const [clienteSearch, setClienteSearch] = useState('');
    const [clienteSelected, setClienteSelected] = useState(null);
    const [loadingCargarCliente, setLoadingCargarCliente] = useState(false);

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [usuarioNameSearch, setUsuarioNameSearch] = useState('');
    const [nameSelected, setNameSelected] = useState(null);
    const [loadingCargarName, setLoadingCargarName] = useState(false);

    const [procesadoPorSelected, setProcesadoPorSelected] = useState(null);




    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');


    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);



    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();



    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (fechaInicio || fechaFin || clienteSelected || localesSelected || estadosSelected || procesadoPorSelected || nameSelected || nroFactura || montoDesde || montoHasta) {

                handleApiFiltrarEventosTituloEstado();
            } else {
                handleApiFiltrarEventos(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, perPage, fechaInicioBackend, fechaFinBackend, clienteSelected, localesSelected, estadosSelected, procesadoPorSelected, nameSelected, nroFactura, montoDesde, montoHasta]);








    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (localesSearch.length > 2) {
                setLoadingCargarLocales(true);
                handleListarLocales(localesSearch);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, localesSearch]);


    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (clienteSearch.length > 2) {
                handleApiFiltrarUsuarios();
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, clienteSearch]);





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarUsuarios = () => {

        let body = {
            page: "",
            per_page: "",
            estado: "",
            term: clienteSearch,
            email: "",
            verificacion: "",
            tipo: "",
            tester: "",

        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargarCliente(true);

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarUsuarios", response);

                setLoadingCargarCliente(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataClientes(response.data);
                } else {
                    setDataClientes([]);
                }




            })
            .catch(error => {
                console.log("error==>getFiltrarUsuarios", error);
                setDataUsuarios([]);
                setLoadingCargarCliente(false);
            })
    };





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventosTituloEstado = () => {

        let body = {
            page: 1,
            per_page: perPage,
            fecha_desde_factura: fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fecha_hasta_factura: fechaFinBackend === "" ? "" : fechaFinBackend,
            cliente: clienteSelected?.id === undefined ? "" : clienteSelected?.id,
            local: localesSelected?.id === undefined ? "" : localesSelected?.id,
            estado: estadosSelected?.value === undefined ? "" : estadosSelected?.value,
            procesado_por: procesadoPorSelected?.value === undefined ? "" : procesadoPorSelected?.value,
            nro_factura: nroFactura,
            procesado_por_user: nameSelected?.id === undefined ? "" : nameSelected?.id,
            monto_desde: montoDesde,
            monto_hasta: montoHasta
        };
        console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarFacturas(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarFacturas", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataFacturas(response.data);
                    setLoading(true);
                } else {
                    setDataFacturas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarFacturas", error);
                setDataFacturas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };




    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {
        //  url: URL + `/filtrar/factura?fecha_desde=${body.fecha_desde_factura}&fecha_hasta=${body.fecha_hasta_factura}&cliente=${body.cliente}&local=${body.local}&estado=${body.estado}&procesado_por=${body.procesado_por}&nro_factura=${body.nro_factura}&procesado_por_user=${body.procesado_por_user}&monto_desde=${body.monto_desde}&monto_hasta=${body.monto_hasta}&page=${body.page}&per_page=${body.per_page}`,

        let body = {
            page: page,
            per_page: perPage,
            fecha_desde_factura: fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fecha_hasta_factura: fechaFinBackend === "" ? "" : fechaFinBackend,
            cliente: clienteSelected?.id === undefined ? "" : clienteSelected?.id,
            local: localesSelected?.id === undefined ? "" : localesSelected?.id,
            estado: estadosSelected?.value === undefined ? "" : estadosSelected?.value,
            procesado_por: procesadoPorSelected?.value === undefined ? "" : procesadoPorSelected?.value,
            nro_factura: nroFactura,
            procesado_por_user: nameSelected?.id === undefined ? "" : nameSelected?.id,
            monto_desde: montoDesde,
            monto_hasta: montoHasta
        };
        console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarFacturas(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataFacturas(response.data);
                    setLoading(true);
                } else {
                    setDataFacturas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error-getFiltrarFacturas==>", error);
                setDataFacturas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };








    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {

        getLocalesFiltrarPorNombre(busqueda, stateToken?.access_token)
            .then((response) => {
                console.log("response-getLocalesFiltrarPorNombre", response?.data);
                setLoadingCargarLocales(false);
                if (response.data.length > 0) {
                    setLocales(response.data);
                } else {
                    setLocales([]);
                }
            })
            .catch((error) => {
                console.log("error-getLocalesFiltrarPorNombre", error);
                setLoadingCargarLocales(false);
                setLocales([]);
            });
    };




















































    //=============================================funcion para capturar el nro de factura
    const handleNroFactura = (e) => {
        setNroFactura(e);
    }

    //=============================================funcion para capturar el monto desde
    const handleMontoDesde = (e) => {
        setMontoDesde(e);
    }

    //=============================================funcion para capturar el monto hasta
    const handleMontoHasta = (e) => {
        setMontoHasta(e);
    }






    //=============================================funcion para editar
    const handleEditClick = (item) => {
        console.log('Edit', item?.id);
        history(`/app/admin/facturas-detalle/${item?.id}`);
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataFacturas(dataFacturas.filter((row) => row.id !== id));
    }




    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);


    };








    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        // console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        // console.log("fecha", fecha);
        setFechaFinBackend(fecha);

    };










    //=============================================funcion para buscar el nombre del cliente
    const handleNameClienteSearch = (e) => {
        setClienteSearch(e);
    };

    //=========================================================funcion para seleccionar el nombre del cliente
    const handleClienteSelected = (value) => {
        // console.log("value-handleClienteSelected##########>>> ", value);
        setClienteSelected(value);

    };









    //=============================================funcion para buscar el nombre del usuario
    const handleUsuarioNameSearch = (e) => {
        // console.log("event-handleNameSearch------>", e);
        setUsuarioNameSearch(e);
    };

    //=========================================================funcion para seleccionar el nombre del usuario
    const handleNameSelected = (value) => {
        // console.log("value-handleNameSelected##########>>> ", value);
        setNameSelected(value);

    };







    //=========================================================funcion para seleccionar el procesado por
    const handleProcesadoSelected = (value) => {
        console.log("value-handleProcesadoSelected: ", value);
        setProcesadoPorSelected(value);

    };









    //=========================================================funcion para seleccionar el estado
    const handleEstadoSelected = (value) => {
        console.log("value-handleEstadoSelected: ", value);
        setEstadosSelected(value);
    };







    //=========================================================funcion para seleccionar local
    const handleLocalSelected = (value) => {
        console.log("value-handleCategoriaSelected: ", value);
        setLocalesSelected(value);
    };

    //=========================================================funcion para buscar local
    const handleSearchLocal = (value) => {
        console.log("value-handleSearchCategoria: ", value);
        setLocalesSearch(value);
    };



    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
























    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitrosFacturasComponent
                            title={'Facturas'}

                            nroFactura={nroFactura}
                            handleNroFactura={handleNroFactura}

                            montoDesde={montoDesde}
                            handleMontoDesde={handleMontoDesde}

                            montoHasta={montoHasta}
                            handleMontoHasta={handleMontoHasta}


                            estadosSelected={estadosSelected}
                            handleEstadoSelected={handleEstadoSelected}



                            dataLocales={locales}
                            loadingCargarLocales={loadingCargarLocales}
                            localesSelected={localesSelected}
                            handleLocalSelected={handleLocalSelected}
                            handleSearchLocal={handleSearchLocal}



                            procesadoPorSelected={procesadoPorSelected}
                            handleProcesadoSelected={handleProcesadoSelected}


                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            clienteSelected={clienteSelected}
                            loadingCargarCliente={loadingCargarCliente}
                            dataClientes={dataClientes}
                            handleNameClienteSearch={handleNameClienteSearch}
                            handleClienteSelected={handleClienteSelected}

                            nameSelected={nameSelected}
                            dataUsuarios={dataUsuarios}
                            loadingCargarName={loadingCargarName}
                            handleUsuarioNameSearch={handleUsuarioNameSearch}
                            handleNameSelected={handleNameSelected}

                            optionsProcesados={optionsProcesados}
                            optionsEstado={optionsEstado}

                        />

                        <div>
                            <FacturasTableComponent
                                data={dataFacturas}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>

                        {/* <div style={{
                            backgroundColor: PaletaColor.BLANCO,
                            borderRadius: Padding.P1,
                            padding: Padding.P3,
                        }}>
                            <Box sx={{ width: '100%' }}>
                                <DataGrid
                                    rows={dataFacturas}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5, 10, 25]}
                                    // checkboxSelection
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </div> */}
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default FacturasPage;